<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-if="loading_page === false">
      <v-card>
        <v-form ref="add_form" @submit.prevent="createSupplier">
          <div class="pa-3">
            <div>
              <v-radio-group v-model="supplier_add.type_supplier">
                <div class="d-flex">
                  <div class="d-flex mr-1">
                    <div>
                      <v-radio color="#86bc3a" value="1"></v-radio>
                    </div>
                    <div>บุคคลธรรมดา</div>
                  </div>
                  <div class="d-flex mr-1">
                    <div>
                      <v-radio color="#86bc3a" value="2"></v-radio>
                    </div>
                    <div>นิติบุคคล</div>
                  </div>
                </div>
              </v-radio-group>
            </div>
            <div>
              <div class="grid_half">
                <div class="mt-3 mr-1">
                  <div class="d-flex">
                    <v-icon>mdi-account</v-icon>
                    <div class="ml-1">รหัสซัพพลายเออร์ : {{ supplier_add.id }}</div>
                  </div>
                </div>
                <div class="mt-3 mr-1">
                  <div class="d-flex align-center">
                  </div>
                </div>
                <div class="mt-3 mr-1">
                  <v-text-field color="#86bc3a" label="ชื่อแผนก" prepend-inner-icon="mdi-account-outline" hide-details="auto"  v-model="supplier_add.department" outlined></v-text-field>
                </div>
                <div class="mt-3 mr-1">
                  <v-text-field color="#86bc3a" label="อีเมล" type="email" @paste="isPaste($event)" @keypress="isEmail($event)" prepend-inner-icon="mdi-email-outline"  hide-details="auto"  v-model="supplier_add.email" outlined></v-text-field>
                </div>
                <div class="mt-3 mr-1">
                  <v-text-field color="#86bc3a" label="ชื่อ (ไทย)" prepend-inner-icon="mdi-account-outline" :rules="[v => !!v || 'กรุณากรอกชื่อ (ไทย)']" hide-details="auto" required v-model="supplier_add.name" outlined></v-text-field>
                </div>
                <div class="mt-3 mr-1">
                  <v-text-field color="#86bc3a" label="ชื่อ (อังกฤษ)" prepend-inner-icon="mdi-account-outline"  hide-details="auto"  v-model="supplier_add.name_eng" outlined></v-text-field>
                </div>
                <div class="mt-3 mr-1">
                  <v-text-field color="#86bc3a" label="ชื่อย่อ" prepend-inner-icon="mdi-account-outline" hide-details="auto" required v-model="supplier_add.short_name" outlined></v-text-field>
                </div>
                <div class="mt-3 mr-1">
                  <v-text-field color="#86bc3a" label="เลขเสียภาษี" type="tel" maxlength="13" @keypress="isTaxNumber($event, supplier_add.tax_number)" prepend-inner-icon="mdi-account-outline"  hide-details="auto"  v-model="supplier_add.tax_number" outlined></v-text-field>
                </div>
              </div>
              <div class="mt-3 mr-1">
                <div class="d-flex">
                  <v-icon>mdi-home</v-icon>
                  <div class="ml-1">ที่อยู่</div>
                </div>
              </div>
              <div class="grid_full">
                <div class="mt-3">
                  <div class="ml-1">บ้านเลขที่/ที่อยู่</div>
                  <v-text-field color="#86bc3a" class="mt-3 mr-1" hide-details="auto" placeholder="ที่อยู่" v-model="supplier_add.address" outlined></v-text-field>
                </div>
              </div>
              <div class="grid_half">
                <div class="mt-3 mr-1">
                  <addressinput-subdistrict class="custom_css" placeholder="ตำบล/แขวง" v-model="supplier_add.sub_district"/>
                </div>
                <div class="mt-3 mr-1">
                  <addressinput-district class="custom_css" placeholder="อำเภอ/เขต" v-model="supplier_add.district"/>
                </div>
                <div class="mt-3 mr-1">
                  <addressinput-province class="custom_css" placeholder="จังหวัด" v-model="supplier_add.province" />
                </div>
                <div class="mt-3 mr-1">
                  <addressinput-zipcode numbered class="custom_css" placeholder="รหัสไปรษณีย์" v-model="supplier_add.postcode" />
                </div>
              </div>
              <div class="grid_half">
                <div class="mt-3 mr-1">
                  <div class="ml-1">เงื่อนไขการรับคืนสินค้าหมดอายุ</div>
                  <v-select class="mt-3" color="#86bc3a" :items="items" item-text="name" item-value="id" prepend-inner-icon="mdi-alarm" label="เงื่อนไขการหมดอายุ"  hide-details="auto"  v-model="supplier_add.type" outlined></v-select>
                </div>
                <div class="mt-3 mr-1">
                  <div class="ml-1">เงื่อนไขเครดิต</div>
                  <v-select class="mt-3" color="#86bc3a" :items="items_credit" item-text="name" item-value="id" prepend-inner-icon="mdi-credit-card" label="เงื่อนไขเครดิต"  hide-details="auto"  v-model="supplier_add.credit_type" outlined></v-select>
                </div>
              </div>
              <div class="grid_full">
                <div class="mt-3 mr-1">
                  <div class="ml-1">หมายเหตุ</div>
                  <v-text-field class="mt-3" color="#86bc3a" label="หมายเหตุ" prepend-inner-icon="mdi-message-bulleted"  hide-details="auto"  v-model="supplier_add.note" outlined></v-text-field>
                </div>
              </div>
              <div v-if="supplier_add.type_supplier === '2'">
                <div class="grid_full">
                  <div class="mt-3 mr-1">
                    <v-text-field color="#86bc3a" label="เครดิต" type="number" prepend-inner-icon="mdi-credit-card" @keypress="isCurrency($event, supplier_add.credit)" hide-details="auto"  v-model="supplier_add.credit" outlined></v-text-field>
                  </div>
                </div>
              </div>
              <div class="d-flex mt-4">
                <v-icon>mdi-account</v-icon>
                <div class="ml-1">ข้อมูลผู้ติดต่อ</div>
              </div>
              <div class="grid_half">
                <div class="mt-3 mr-1">
                  <v-text-field color="#86bc3a" label="ชื่อ - สกุล" prepend-inner-icon="mdi-account-outline"  hide-details="auto" v-model="supplier_add.contact_name" outlined></v-text-field>
                </div>
                <div class="mt-3 mr-1">
                  <v-text-field color="#86bc3a" type="tel" label="เบอร์โทร" maxlength="10" @keypress="isNumber($event, supplier_add.contact_telephone)" prepend-inner-icon="mdi-phone-outline" hide-details="auto"  v-model="supplier_add.contact_telephone" outlined></v-text-field>
                </div>
              </div>
              <div class="text-center mt-3">
                <v-btn x-large type="submit" class="grad-success-bg white--text ml-2" style="font-size: 18px">บันทึกข้อมูล</v-btn>
              </div>
            </div>
          </div>
        </v-form>
      </v-card>
    </div>
  </div>
</template>

<script>
import { HTTP } from '@/axios.js'
import Swal from 'sweetalert2'
import {isTelephone, onlyForCurrency, onPaste, taxNumber, validateEmail} from "@/js/handler";
export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "SupplierFrom",
  data() {
    return {
      loading_page: false,
      emailRules: [v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'อีเมลไม่ถูกต้อง !'],
      taxRules: [v => ( v.length === 13 ) || "เลขเสียภาษีไม่ถูกต้อง !",],
      items: [
        {id: 0, name: 'ไม่มี'},
        {id: 3, name: '3 เดือน'},
        {id: 1, name: '6 เดือน'},
        {id: 2, name: '7 เดือน'},
        {id: 8, name: '8 เดือน'},
        {id: 4, name: '9 เดือน'},
        {id: 5, name: '10 เดือน'},
        {id: 6, name: '11 เดือน'},
        {id: 7, name: '12 เดือน'},
      ],
      items_credit: [
        {id: 0, name: 'ไม่มี'},
        {id: 1, name: '30 วัน'},
        {id: 2, name: '60 วัน'},
        {id: 3, name: '90 วัน'},
        {id: 4, name: '120 วัน'},
        {id: 5, name: '180 วัน'},
      ],
      supplier_add: {
        type_supplier: '1',
        type: 0,
        credit_type: 0,
        id: null,
        department: '-',
        short_name: null,
        name: null,
        name_eng: null,
        email: '',
        tax_number: '',
        address: null,
        sub_district: null,
        district: null,
        province: null,
        postcode: null,
        note: '-',
        credit: 0,
        contact_name: null,
        contact_telephone: '',
      },
    }
  },
  methods: {
    isNumber: function (evt, number) {
      return isTelephone(evt, number)
    },
    isTaxNumber: function (evt, number) {
      return taxNumber(evt, number)
    },
    isCurrency: function (evt, number) {
      return onlyForCurrency(evt, number)
    },
    isEmail: function (evt) {
      return validateEmail(evt)
    },
    isPaste: function (evt) {
      return onPaste(evt)
    },
    genIdCode() {
      this.loading_page = true
      HTTP.post('/suppliers/getsupid')
          .then((res) => {
            if (res.data.success === true){
              this.loading_page = false
              this.supplier_add.id = res.data.object;
            }
          })
    },
    createAlert() {
      Swal.fire('บันทึกข้อมูลเรียบร้อย', '', 'success')
          .then(() => {
            this.$router.push('/supplier')
          })
    },
    createSupplier(){
      if (this.$refs.add_form.validate()) {
        HTTP.post('/suppliers/create', {
          supplier_code: this.supplier_add.id,
          supplier_type: this.supplier_add.type_supplier,
          department: this.supplier_add.department, //เพิ่ม field department ด้วย
          short_name: this.supplier_add.short_name,
          name: this.supplier_add.name,
          name_eng: this.supplier_add.name_eng,
          tax_number: this.supplier_add.tax_number,
          address: this.supplier_add.address,
          sub_district: this.supplier_add.sub_district,
          district: this.supplier_add.district,
          province: this.supplier_add.province,
          postcode: this.supplier_add.postcode,
          email: this.supplier_add.email,
          note: this.supplier_add.note,
          expiration: this.supplier_add.type,
          credits_condition: this.supplier_add.credit_type,
          name_contact: this.supplier_add.contact_name,
          telephone_contact: this.supplier_add.contact_telephone,
          credit: this.supplier_add.credit
        }, {
          headers: {
            "Authorization": null
          }
        }).then((res) => {
          if (res.data.success === true){
            this.createAlert();
          }
        })
      }
      else {
        Swal.fire({
          title: 'ไม่สามารถดำเนินการได้ !',
          text: 'กรุณากรอกข้อมูล !',
          icon: 'error',
          showDenyButton: false,
          showCancelButton: false,
          confirmButtonText: `ตกลง`,
          denyButtonText: `ยกเลิก`,
        })
      }
    },
  },
  mounted() {
    this.genIdCode();
  }
}
</script>

<style scoped>
.custom_css >>> input {
  font-size: 18px;
  border-color: #9b9b9b;
  border-radius: 5px;
  padding: 16px;
  height: 56px !important;
}
.custom_css >>> input:hover {
  border-color: black;
}
.custom_css >>> input:focus {
  border-color: #8cc63e !important;
  border: solid 2px;
  padding: 15px;
}
.grid_half {
  display: grid;
  grid-template-columns: 50% 50%;
}

.grid_full {
  display: grid;
  grid-template-columns: 100%;
}
@media only screen and (max-width: 500px) {
  .grid_half {
    display: grid;
    grid-template-columns: 100%;
  }
}
</style>
